export type { Props as ErrorStateProps } from './ErrorState'
export { default as ErrorState } from './ErrorState'
